export default __webpack_public_path__ + "static/media/DAR.15afa0ee.svg";